// İSG uzmanı portalı — yönetim (admin) TanStack Query anahtarları. Liste anahtarları
// parametreleri içerir (sayfa/arama değişince yeniden çeker); invalidasyon önek
// (prefix) ile yapılır: `['admin','roles']` tüm rol listesi sorgularını kapsar.

import type { AdminListParams } from '@isgportal/shared';

export const adminKeys = {
  roles: (params?: AdminListParams) =>
    params ? (['admin', 'roles', params] as const) : (['admin', 'roles'] as const),
  role: (uuid: string) => ['admin', 'role', uuid] as const,
  rolePermissions: (uuid: string) => ['admin', 'role-permissions', uuid] as const,
  companies: (params?: AdminListParams) =>
    params ? (['admin', 'companies', params] as const) : (['admin', 'companies'] as const),
  company: (uuid: string) => ['admin', 'company', uuid] as const,
  branches: (companyUuid: string, params?: AdminListParams) =>
    params
      ? (['admin', 'branches', companyUuid, params] as const)
      : (['admin', 'branches', companyUuid] as const),
  sites: (companyUuid: string, branchUuid: string, params?: AdminListParams) =>
    params
      ? (['admin', 'sites', companyUuid, branchUuid, params] as const)
      : (['admin', 'sites', companyUuid, branchUuid] as const),
} as const;
